import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Navbar from "./components/Navbar"
import Home from "./components/Home"
import Mining from "./components/Mining"
import WhyUs from "./components/whychooseus"
import PricingPlans from "./components/Pricing plans/PricingPlans"
import AdmainPanle from "./components/AdmainPanle/Page"
import UserDashboard from "./components/UserDashboard/mining-dashboard"
import LoginPage from "./components/LogIn"
import UserDetailsPage from "./components/AdmainPanle/id/page"
import UserDashboardProtect from "./components/ProtectRoutes/UserDashboardProtect";
import AdminDashboardProtect from "./components/ProtectRoutes/AdminDashboardProtect";
import CutEmerald from "./components/CutEmerald/cut-emeralds-page"
import RoughEmerald from "./components/RoughEmerald/rough-emeralds-page"


// Contxt import
import { AuthProvider } from "./components/contexts/AuthContext"


function App() {
  return (
    <Router>
      <AuthProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop-cutemerald" element={<CutEmerald/>} />
        <Route path="/shop-roughemerald" element={<RoughEmerald />} />
        <Route path="/mining" element={<Mining />} />
        <Route path="/whyus" element={<WhyUs />} />
        <Route path="/pricing-plans" element={<PricingPlans />} />  



         {/* Log in page */}
          <Route path="/login" element={<LoginPage/>}/>


       {/* User Dashboard restricted to users  */}
       <Route path="/user-dashboard/:id" element={
        <UserDashboardProtect>
          <UserDashboard />
        </UserDashboardProtect>
        

        } />  
              
    
        {/* Admain Panle REstricted to admain  */}
      
        <Route path="/dashboard/admin" element={
          <AdminDashboardProtect>
            <AdmainPanle/>
          </AdminDashboardProtect>
          } />  

        
        <Route
          path="/users/:id"
          element={
            <AdminDashboardProtect>
              <UserDetailsPage/> 
            </AdminDashboardProtect>
          }
        />

      <Route path="*" element={<Home />} />
      </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App